<template>
  <div class="bas-dropdown" :class="{ collapsed }">
    <div class="label" v-if="label">
      <span>
        {{ label }}
      </span>
    </div>
    <div class="dropdown-container">
      <button
        @click="onDropDownClick"
        @keyup.down="onDropDownClick"
        @keyup.space="onDropDownClick"
        @keyup.up="onDropDownClick"
        :aria-expanded="collapsed"
        :aria-label="label"
        aria-haspopup="true"
        aria-controls="dropdownmenu"
        class="header pure-button"
        id="dropdownbutton"
        tabindex="0"
      >
        <div class="selection-overlay" v-if="selection">
          <span>{{ selection }}</span>
        </div>
        <div class="left"></div>
        <div class="right">
          <div class="arrow-down"></div>
        </div>
      </button>
      <ul
        v-if="collapsed"
        aria-label="Dropdown Options"
        class="options-container"
        id="dropdownmenu"
        role="menu"
      >
        <li
          v-for="(option, index) in options"
          @blur="handleBlur"
          @click="handleSelection(option.label ? option.label : option)"
          @focus="e => (focusedOption = e.target)"
          @keydown.enter="handleSelection(option.label ? option.label : option)"
          @keyup.down="shiftOptionFocus(options.length - 1 === index ? index : index + 1)"
          @keyup.esc="() => (collapsed = false)"
          @keyup.up="shiftOptionFocus(index ? index - 1 : index)"
          :class="`option dropdown-${dropDownId}-option`"
          :data-index="index"
          :key="index"
          role="menuitem"
          tabindex="0"
        >
          {{ option.label ? option.label : option }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    enabled: {
      type: Boolean,
      default: true
    },
    dropDownId: {
      type: String
    },
    label: {
      type: String
    },
    onItemSelect: {
      type: Function,
      required: true
    },
    options: {
      type: Array,
      required: true
    },
    onOpen: {
      type: Function,
      required: true
    }
  },
  data() {
    return {
      collapsed: false,
      focusedOption: null,
      selection: null
    };
  },
  methods: {
    handleBlur(e) {
      setTimeout(() => {
        if (e.target.getAttribute('data-index') === this.focusedOption.getAttribute('data-index')) {
          this.collapsed = false;
        }
      }, 250);
    },

    handleSelection(option) {
      this.onItemSelect({
        dropDownId: this.dropDownId,
        option
      });

      this.selection = option;
      this.collapsed = false;
    },

    onDropDownClick(e) {
      if (this.collapsed) return;

      this.collapsed = !this.collapsed;

      if (this.collapsed) {
        this.onOpen(this.dropDownId, this.collapsed);

        setTimeout(() => {
          const optionNodes = document.getElementsByClassName(`dropdown-${this.dropDownId}-option`);
          optionNodes.item(0).focus();
        }, 250);
      }
    },

    shiftOptionFocus(index) {
      const optionNodes = document.getElementsByClassName(`dropdown-${this.dropDownId}-option`);
      optionNodes.item(index).focus();
    }
  }
};
</script>

<style lang="scss" scoped>
.bas-dropdown {
  position: relative;
  z-index: 500;
  width: 100%;
  opacity: 0;

  &.collapsed {
    z-index: 510;
  }

  .label {
    font-family: 'hwtfutura-bold';
    font-size: 20px;
    text-align: left;
    margin-bottom: 5px;
  }

  .dropdown-container {
    position: relative;
    width: 100%;
    border: none;
    background-color: white;
    padding: 0 0 0 0;

    .header {
      position: relative;
      height: 44px;
      border: 2px solid black;
      z-index: 1;
      width: 100%;
      cursor: pointer;

      background: transparent;

      padding: 0px;

      &:focus-visible {
        outline: 5px auto #015fcc;
      }

      .selection-overlay {
        position: absolute;
        padding-left: 10px;
        // compensate parent border
        top: -3px;
        left: -3px;
        width: 100%;
        // add border to fit parent and be able to use percentage
        border: 3px solid yellow;
        background-color: yellow;
        color: blue;
        font-size: 20px;
        font-family: 'hwtfutura-bold';
        text-align: left;
        line-height: 40px;
        cursor: default;
      }

      .left,
      .right {
        display: inline-block;
      }

      .left {
        font-size: 20px;
        font-family: 'hwtfutura-bold';
      }

      .right {
        float: right;
        border-left: 1px solid black;
        width: 35px;
        height: 100%;
      }

      .arrow-down {
        width: 0;
        height: 0;
        border-left: 6px solid transparent;
        border-right: 6px solid transparent;
        border-top: 10px solid black;
        margin-top: 13px;
        margin-left: 11px;
      }

      .right {
        float: right;
      }
    }

    .options-container {
      position: absolute;
      top: 46px;
      left: 0;
      z-index: 2;
      width: 100%;
      background-color: yellow;
      padding: 0px;
      list-style: none;
      margin: 0px;

      .option {
        font-family: hwtfutura;
        font-size: 20px;
        text-align: left;
        padding: 5px 10px 5px 10px;
        color: blue;
        transition: 0.5s;
        cursor: pointer;

        &:hover,
        &:focus-visible {
          background-color: blue;
          color: yellow;
        }
      }
    }
  }
}
</style>
